import Auth from '../../../lib/commons/auth'
import UserApi, {
  RegistrationStatus,
  UserDetail,
  isEmailChangable,
} from '../../../lib/functions/user'
import store from '../../../store'
import DateRangeVO from '../../../vo/DateRangeVO'
import TextVO from '../../../vo/TextVO'
import { SingleSheetConverterSpec } from '../../containers/meta/DataConverter/SingleSheetDataConverter'
import {
  SingleSheetContext,
  SingleSheetOptions,
  SingleSheetRepository,
} from '../../containers/SingleSheet'
import { APIResponse } from '../../../lib/commons/api'
import { TableData } from '../../containers/SingleSheet/DataTable'
import DateTimeRangeVO from '../../../vo/DateTimeRangeVO'
import { SubmitType } from '../../containers/meta/ViewMeta'
import { AttemptChangeUserEmailButton } from '../User/AttemptChangeUserEmailButton'
import {
  ToolBarItemPosition,
  generateToolBarItemKey,
} from '../../components/toolbars/ContainerToolBar'

class MeConverterSpec extends SingleSheetConverterSpec {
  convertDeserialized(src: any, dest: any) {
    return {
      ...dest,
      hireLeaveDate: new DateRangeVO({
        startDate: src.hireDate,
        endDate: src.leaveDate,
      }),
      expirationDate: new DateTimeRangeVO({
        startDateTime: src.validFrom,
        endDateTime: src.validTo,
      }),
      githubUserName: src.githubUserName
        ? new TextVO(src.githubUserName)
        : new TextVO(''),
      permissionPolicies: src.permissionPolicies
        ? new TextVO(src.permissionPolicies.map(v => v.name).join(','))
        : new TextVO(''),
    }
  }
  convertSerialized({
    dest,
    initialData,
    delta,
  }: {
    src: any
    dest: any
    initialData?: any
    submitType: SubmitType
    delta?: any
  }): {
    before?: any
    after: any
    delta?: any
  } {
    return {
      before: initialData,
      after: dest,
      delta: delta
        ? {
            uuid: dest.uuid,
            ...delta,
          }
        : undefined,
    }
  }
  convertInitialData(dest: any, auxiliaries: any) {
    return dest
  }
}

class MeData extends TableData {
  code?: TextVO
  name?: TextVO
  getCode() {
    return this.code
  }
  getName() {
    return this.name
  }
}

export class Me extends SingleSheetOptions<MeData> {
  converterSpec = new MeConverterSpec()
  registrationStatus: RegistrationStatus = RegistrationStatus.PROVISIONAL

  afterGet = (data: UserDetail) => {
    const currentUser = store.getState().user.user
    if (currentUser && currentUser.uuid === data.uuid) {
      const tenant = Auth.getCurrentTenant()!
      tenant.refreshUser()
    }
    this.registrationStatus = data.registrationStatus
    return data
  }

  getMyBasic = async (): Promise<APIResponse> => {
    return UserApi.me()
  }

  toolBarItems = (ctx: SingleSheetContext<MeData>) => {
    const userUuid = ctx.state.data.uuid
    if (!userUuid) return []
    const registrationStatus = ctx.state.data['registrationStatus']
      .value as RegistrationStatus
    if (!isEmailChangable(registrationStatus)) return []
    return [
      <div key={generateToolBarItemKey(1, ToolBarItemPosition.END)}>
        <AttemptChangeUserEmailButton
          uuid={userUuid}
          key={'attempt-change-user-email-button'}
        />
      </div>,
    ]
  }
}

export const meRepository: SingleSheetRepository = {
  create(): Promise<APIResponse> {
    throw new Error('create is not supported for /me')
  },
  update(): Promise<APIResponse> {
    throw new Error('update is not supported for /me')
  },
  updateDelta(props: any): Promise<APIResponse> {
    const { uuid, ...rest } = props
    return UserApi.updateMeDelta(rest)
  },
  getDetail(): Promise<APIResponse> {
    return UserApi.me()
  },
  getBasicByCode(): Promise<APIResponse> {
    throw new Error('getBasicByCode is not supported for /me')
  },
}
